import React from 'react';
import CustomSelectDropdown from 'components/shared/DropDown/CustomSelectDropdown';
import { useTranslation } from 'react-i18next';

export const MODELS = {
    openai: [
        { type: 'gpt-5', name: 'gpt-5' },
        { type: 'gpt-5-mini', name: 'gpt-5-mini' },
        { type: 'gpt-5-nano', name: 'gpt-5-nano' },
        { type: 'gpt-4.1', name: 'gpt-4.1' },
        { type: 'o4-mini', name: 'o4-mini' },
        { type: 'gpt-4o', name: 'gpt-4o' },
        { type: 'chatgpt-4o-latest', name: 'chatgpt-4o-latest' },
        { type: 'gpt-4o-mini', name: 'gpt-4o-mini' },
        { type: 'gpt-4-turbo', name: 'gpt-4-turbo' },
        { type: 'gpt-4', name: 'gpt-4' },
    ],
    claude: [
        { type: 'claude-sonnet-4-6', name: 'claude-sonnet-4-6' },
        { type: 'claude-opus-4-6', name: 'claude-opus-4-6' },
        { type: 'claude-sonnet-4-5', name: 'claude-sonnet-4-5' },
        { type: 'claude-sonnet-4-5-20250929', name: 'claude-sonnet-4-5-20250929' },
        { type: 'claude-haiku-4-5', name: 'claude-haiku-4-5' },
        { type: 'claude-opus-4-5', name: 'claude-opus-4-5' },
        { type: 'claude-opus-4-1', name: 'claude-opus-4-1' },
        { type: 'claude-sonnet-4-0', name: 'claude-sonnet-4-0' },
        { type: 'claude-opus-4-0', name: 'claude-opus-4-0' },
    ],
    gemini: [
        { type: 'gemini-3-flash-preview', name: 'gemini-3-flash-preview' },
        { type: 'gemini-3.1-pro-preview', name: 'gemini-3.1-pro-preview' },
        { type: 'gemini-3.1-flash-lite-preview', name: 'gemini-3.1-flash-lite-preview' },
        { type: 'gemini-2.5-pro', name: 'gemini-2.5-pro' },
        { type: 'gemini-2.5-flash', name: 'gemini-2.5-flash' },
        { type: 'gemini-2.5-flash-lite', name: 'gemini-2.5-flash-lite' },
        { type: 'gemini-1.5-pro', name: 'gemini-1.5-pro' },
        { type: 'gemini-1.5-flash', name: 'gemini-1.5-flash' },
        { type: 'gemini-1.5-flash-8b', name: 'gemini-1.5-flash-8b' },
    ],
    perplexity: [
        { type: 'sonar', name: 'sonar' },
        { type: 'sonar-pro', name: 'sonar-pro' },
        { type: 'sonar-deep-research', name: 'sonar-deep-research' },
        { type: 'sonar-reasoning-pro', name: 'sonar-reasoning-pro' },
    ],
};

export const DEFAULT_MODELS = {
    openai: { type: 'gpt-5', name: 'gpt-5' },
    claude: { type: 'claude-sonnet-4-6', name: 'claude-sonnet-4-6' },
    gemini: { type: 'gemini-2.5-pro', name: 'gemini-2.5-pro' },
    perplexity: { type: 'sonar', name: 'sonar' },
};

export default function ModelSelect({ provider, value, onChange }) {
    const { t } = useTranslation();

    const list = MODELS[provider] || [];
    const safeValue = value ?? DEFAULT_MODELS[provider] ?? null;

    return (
        <div className="ai-field">
            <label>{t('Modèle par défaut')}</label>

            <CustomSelectDropdown
                className="ai-card-select"
                options={list}
                value={safeValue}
                onChange={(option) => onChange(option)}
                placeholder={t('Sélectionner une option')}
                getOptionLabel={(option) => option?.name}
                getOptionValue={(option) => option?.type}
                inputStyle={{ backgroundColor: '#fff', minHeight: '28px', padding: '0 0.5rem', fontSize: '12px' }}
                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                menuPosition="fixed"
                styles={{ menuPortal: () => ({ zIndex: 9999 }) }}
            />
        </div>
    );
}